// extracted by mini-css-extract-plugin
export default {"element":"MapInternal__element___q6xwT"};